import posthog from "posthog-js";
import { env, isPosthogConfigured } from "@/lib/env";

export type NoticeAttributionState = "allowed" | "analytics_disabled" | "sdk_not_ready" | "opted_out";

/** Never use a first-party collector as a fallback around an opted-out SDK. */
export function noticeAttributionState(): NoticeAttributionState {
  if (env.appEnv !== "production" || !isPosthogConfigured) return "analytics_disabled";
  if (!posthog.__loaded) return "sdk_not_ready";
  // Cookieless capture can be enabled even when identifiable capture is opted
  // out. That must not authorize this actor/delivery-linked collector.
  try { return !posthog.has_opted_out_capturing() && posthog.is_capturing() ? "allowed" : "opted_out"; }
  catch { return "sdk_not_ready"; }
}
